/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconInfoSmall = createReactComponent("outline", "info-small", "IconInfoSmall", [["path", { "d": "M12 9h.01", "key": "svg-0" }], ["path", { "d": "M11 12h1v4h1", "key": "svg-1" }]]);

export { IconInfoSmall as default };
//# sourceMappingURL=IconInfoSmall.mjs.map
